import React from 'react';
import { SparklesIcon, DocumentIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

// Helper to get border color for selection
const getBorderClass = (method, selectedMethod) => {
  return selectedMethod === method ? 'border-purple-500 border-2' : 'border-accent';
};

// Helper to get background color for selection and hover states
const getBackgroundClass = (method, selectedMethod) => {
  if (selectedMethod === method) {
    return 'bg-accent'; // Same selected background for both options
  } else {
    return 'hover:bg-accent'; // Same hover background for both options
  }
};

const MethodSelectionStep = ({ selectedMethod, onMethodSelect }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-medium mb-1">Create a new lesson</h2>
      <p className="text-lg text-primary/60 font-light">Start building a new lesson for your Pathway — either with help from AI or from scratch.</p>
      <div className="flex flex-col space-y-4">
        {/* AI Assisted Box */}
        <div className="flex-1">
          <div
            className={`relative border rounded-lg flex items-start p-4 transition-colors ${getBorderClass('ai', selectedMethod)} ${getBackgroundClass('ai', selectedMethod)}`}
            onClick={() => onMethodSelect('ai')}
          >
            <span className={`absolute top-2 right-2 px-2.5 py-1 rounded-md text-sm font-medium ${selectedMethod === 'ai' ? 'bg-purple-200 text-purple-800' : 'bg-accent'}`}>
              Recommended
            </span>
            
            {/* Selection checkmark - positioned like in PathwayTypeStep */}
            {selectedMethod === 'ai' && (
              <CheckCircleIcon className="h-5 w-5 text-purple-600 absolute bottom-4 right-4" />
            )}
            
            <div className="flex flex-col items-start cursor-pointer">
              <SparklesIcon className="h-6 w-6 mb-2 text-primary" />
              <span className="font-normal text-lg">Start with AI</span>
              <span className="text-base text-primary/60 mt-1">Let AI turn your content into a lesson</span>
            </div>
          </div>
        </div>

        {/* Manual Box */}
        <div className="flex-1">
          <div
            className={`relative border rounded-lg flex items-start p-4 transition-colors ${getBorderClass('manual', selectedMethod)} ${getBackgroundClass('manual', selectedMethod)}`}
            onClick={() => onMethodSelect('manual')}
          >
            {/* Selection checkmark - positioned like in PathwayTypeStep */}
            {selectedMethod === 'manual' && (
              <CheckCircleIcon className="h-5 w-5 text-purple-600 absolute bottom-4 right-4" />
            )}
            
            <div className="flex flex-col items-start cursor-pointer">
              <DocumentIcon className="h-6 w-6 mb-2 text-primary" />
              <span className="font-normal text-lg">Start from scratch</span>
              <span className="text-base text-gray-500 mt-1">Build your own lesson block by block</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MethodSelectionStep; 